import {USER_DATA, DEFAULT_REDIRECT, WasteGenerators, Regions} from "../config/config"

const savedData = {
  user: null
};

if (typeof window !== "undefined") {
  savedData.user = window.localStorage.getItem(USER_DATA) ? JSON.parse(window.localStorage.getItem(USER_DATA)) : null
}

export const notReactiveState = {
  endpoints: {}
};

export default {
  _userData: savedData.user,
  _error: null,
  _redirectUrl: DEFAULT_REDIRECT.user,
  years:[],
  user: {},
  _needReLogin: {value: false, createdAt: +new Date()},
  menustate: false,
  routes: [],
  endpoints: {},
  cache: {},
  tables: {
    disableReload: {}
  },
  skipAsyncData: {},
  showMapLegend: true,
  showMappingLayer: true,
  forms: {
    disabledForms: {}
  },
  breadcrumbs: {},
  charts: {
    dynamic: {
      viewMode: WasteGenerators
    },
    garbage: {
      viewMode: WasteGenerators
    },
    garbageHandlingDynamic: {
      viewMode: WasteGenerators
    },
    garbageProduction: {
      viewMode: WasteGenerators
    },
    garbageVolume: {
      viewMode: WasteGenerators
    },
    msn: {
      viewMode: WasteGenerators
    },
    msnContainer: {
      viewMode: WasteGenerators
    },
    garbageOutput: {
      viewMode: Regions
    }
  },
  preloader: false,
  preloaderOn: false,
  preloaderLoad: 0
}
